import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.993 4.883A1 1 0 0 0 15 5v11.585l-3.543-3.54-.094-.084a1 1 0 0 0-1.32 1.498l5.25 5.248.094.083a1 1 0 0 0 1.32-.083l5.25-5.248.083-.095a1 1 0 0 0-.083-1.32l-.094-.083a1 1 0 0 0-1.32.083l-3.544 3.542L17 5zm-11 14A1 1 0 0 0 4 19v7l.005.15A2 2 0 0 0 6 28h20l.15-.006A2 2 0 0 0 28 26v-7l-.007-.117A1 1 0 0 0 26 19v7H6v-7z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconDownload = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconDownload);
export default Memo;
